import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FoodManagementSystem.css';
import { downloadResume } from '../utils/resumeDownload';

const FoodManagementSystem = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleResumeDownload = downloadResume;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="food-management-system">
      {/* Header with Background */}
      <header className="header">
        <div className="header-content">
          <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>Subs.</div>
          <nav className="navigation desktop-nav">
            <a href="/about">About</a>
            <a href="/#works">Works</a>
            <a href="/#resume" onClick={handleResumeDownload}>Resume</a>
            <a href="/contact">Contact</a>
          </nav>
          
          {/* Mobile menu button */}
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        
        {/* Mobile Navigation - Offset Canvas */}
        <div className={`mobile-nav-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={closeMobileMenu}></div>
        <div className={`mobile-nav-canvas ${isMobileMenuOpen ? 'active' : ''}`}>
          <div className="mobile-nav-header">
            <div className="logo mobile-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>Subs.</div>
            <button className="close-menu-btn" onClick={closeMobileMenu} aria-label="Close menu">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <nav className="mobile-nav">
            <a href="/about" onClick={closeMobileMenu}>About</a>
            <a href="/#works" onClick={closeMobileMenu}>Works</a>
            <a href="/#resume" onClick={(e) => { handleResumeDownload(); closeMobileMenu(); }}>Resume</a>
            <a href="/contact" onClick={closeMobileMenu}>Contact</a>
          </nav>
        </div>
      </header>

      {/* Header Section */}
      <div className="header-section">
        <h1 className="main-title">Food Management System.</h1>
        <div className="project-details">
          <div className="project-details-row">
            <div className="detail-item">
              <span className="detail-label">Role</span>
              <div className="detail-separator"></div>
              <span className="detail-value">Product Designer</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Timeline</span>
              <div className="detail-separator"></div>
              <span className="detail-value">2  months</span>
            </div>
          </div>
          <div className="detail-item">
            <span className="detail-label">Tools</span>
            <div className="detail-separator"></div>
            <span className="detail-value">Figma, FigJam</span>
          </div>
        </div>
      </div>

      {/* Image Section - Placeholder for your image */}
      <div className="image-section">
        <div className="image-container">
          {/* TODO: Update the src path with your actual image path */}
          <img 
            src="/foodmanagementsystem.png" 
            alt="Food Management System UI" 
            className="system-image"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="image-placeholder" style={{ display: 'none' }}>
            <svg className="placeholder-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p>Image placeholder - Update the src path in FoodManagementSystem.js</p>
          </div>
        </div>
      </div>

      {/* Project Information Section */}
      <div className="project-info-section">
        <div className="project-info-container">
          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Project Overview</h3>
            </div>
            <div className="section-content">
              <p className="section-description">
                A dedicated canteen management system designed for companies to efficiently manage employee food services. It enables businesses to track user activity, orders, and streamline food delivery within the corporate environment.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Identifying Problem</h3>
            </div>
            <div className="section-content">
              <p className="section-description">
                Companies find it hard to manage food services for employees. Tracking orders, handling preferences, and delivering food on time are challenging with traditional systems, often leading to delays and frustration. A better system is needed to make food service faster and easier for everyone.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Defining Roles & Building Information Architecture</h3>
            </div>
            <div className="section-content">
              <div className="content-image-layout">
                <div className="content-text">
                  
                </div>
                <div className="content-image">
                  <img 
                    src="/definingrolesbuildinginformationarchitectire.png" 
                    alt="Roles and Information Architecture" 
                    className="content-section-image"
                  />
                </div>
              </div>
            </div>
          </div>



              {/* work flow and user story */}  
            <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Workflows & User Story</h3>
            </div>
            <div className="section-content">
             
              <div className="content-image-full-width">
                <img 
                  src="/workflowsuserstory.png" 
                  alt="Workflows and User Story" 
                  className="content-section-image"
                />
              </div>
            </div>
          </div>

            {/*As a guest */}  
          <div className="info-section">
            
            <div className="section-content">
              <div className="content-image-layout">
                <div className="content-text">
                  <p className="section-description">
                  <b>As a Guest</b>, I log in to access the Landing Page, 
                  browse the Categorical Menu, and select items to order. 
                  I proceed through Place Order by choosing items, adding Notes,
                  and confirming. Finally, I review my selections on Checkout and complete my order.
                  </p>
                </div>
                <div className="content-image">
                  <img 
                    src="/asaguest.png" 
                    alt="Guest Workflow" 
                    className="content-section-image"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Admin Workflow */}
          <div className="info-section">
            
            <div className="section-content">
              <div className="content-image-full-width">
                <img 
                  src="/adminworkflow.png" 
                  alt="Admin Workflow" 
                  className="content-section-image"
                />
              </div>
            </div>
          </div>

          {/* Spacing between sections */}
          <div style={{ height: '2rem' }}></div>

           {/*As a Admin */}  
           <div className="info-section">
            
            <div className="section-content">
              <div className="content-image-layout">
                <div className="content-text">
                  <p className="section-description">
                  <b>As an Admin</b>, I log in to access the Dashboard,
                   manage the Menu and Categories, add Special Items, monitor
                    the Order Process, and review past orders in History.
                  </p>
                </div>
                <div className="content-image">
                  <img 
                    src="/userstoryadmin.png" 
                    alt="Guest Workflow" 
                    className="content-section-image"
                  />
                </div>
              </div>
            </div>
          </div>

           {/* Spacing between sections */}
           <div style={{ height: '2rem' }}></div>

           {/*Story Board */}  
           <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Storyboard</h3>
            </div>
            <div className="section-content">
              <div className="storyboard-image-container">
                <img 
                  src="/storyboard.png" 
                  alt="Storyboard" 
                  className="storyboard-image"
                />
              </div>
            </div>
          </div>

          
           {/* Spacing between sections */}
           <div style={{ height: '2rem' }}></div>

           {/*Low-Fidelity Wireframes */}  
           <div className="info-section">
            <div className="section-header">
              <span className="section-line">—</span>
              <h3 className="section-title">Low-Fidelity Wireframes</h3>
            </div>
            <div className="section-content">
              <div className="storyboard-image-container">
                <img 
                  src="/lowfid.png" 
                  alt="Storyboard" 
                  className="storyboard-image"
                />
              </div>
            </div>
          </div>

          {/* Spacing between sections */}
          <div style={{ height: '2rem' }}></div>

                     {/* High Fidelity */}
           <div className="info-section">
             <div className="high-fidelity-container">
               {/* Left Panel - Text Content */}
               <div className="text-panel">
                 <div className="main-header">
                   — High-Fidelity Wireframes
                 </div>
                 
                 <div className="subsection-header">
                   —Homepage
                 </div>
                 
                 <div className="description-text">
                   This page allows users to browse and order food items effectively, 
                   including viewing the daily menu, selecting meal combinations, 
                   and managing their food preferences. It also displays an 
                   interactive menu with categories and real-time order tracking.
                 </div>
               </div>

               {/* Right Panel - Image */}
               <div className="image-panel">
                 <div className="image-placeholder">
                   <img 
                     src="/naasameshhomepage.png" 
                     alt="Homepage High Fidelity" 
                     className="mobile-app-image"
                   />
                 </div>
               </div>

               {/* Full Line Separator */}
               <div className="full-line-separator"></div>

               {/* Left Panel - Text Content (Duplicate) */}
               <div className="text-panel">
                 <div className="subsection-header">
                   —Current Orders
                 </div>
                 
                 <div className="description-text">
                 This page allows users to manage trades effectively, 
                 including placing buy/sell orders, viewing top buy/sell stats,
                  and monitoring collateral details. It also displays an interactive 
                  order book to track order statuses and execution.
                 </div>
               </div>

               {/* Right Panel - Image (Duplicate) */}
               <div className="image-panel">
                 <div className="image-placeholder">
                   <img 
                     src="/naasameshhomepage.png" 
                     alt="Current Orders High Fidelity" 
                     className="mobile-app-image"
                   />
                 </div>
               </div>
             </div>
           </div>





        </div>
      </div>

      {/* Back Button */}
      <div className="back-section">
        <button className="back-btn" onClick={() => window.history.back()}>
          <svg className="back-arrow" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span>Back to Portfolio</span>
        </button>
      </div>
    </div>
  );
};

export default FoodManagementSystem;
